import React, { Component } from 'react'
import Box from '@mui/material/Box';
import colors from './Colors';


export class Doctor extends Component {
  render() {
    return (
        <Box
        sx={{
            width: "80vw",
            height: "90vh",
            backgroundColor: colors['doctor'],
        }}
        className='das-body'
    >

    </Box>
    )
  }
}

export default Doctor